import { HttpParams } from '@angular/common/http';
import { Filter } from '../../../../models';

/** Representa o Filter da pesquisa dos pacotes de campanhas */
export class PacoteCampanhaFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    idsAreas: number[] = [];
    situacoes: number[] = [];
    tiposPromocoes: number[] = [];
    tipoPromocaoNull = false;
    sobDemanda: boolean;

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Áreas
        this.idsAreas?.forEach(idArea => {
            params = params.append('idArea', idArea.toString());
        });

        // Situação
        this.situacoes?.forEach(situacao => {
            params = params.append('situacao', situacao.toString());
        });

        // Tipos de Promoções
        this.tiposPromocoes?.forEach(tipoPromocao => {
            if (tipoPromocao > 0) {
                params = params.append('tipoPromocao', tipoPromocao.toString());
            }
        });
        // Sem tipo de promoção
        if (this.tipoPromocaoNull) {
            params = params.append('tipoPromocaoNull', 'true');
        }

        // Sob demanda
        if (this.sobDemanda != null && this.sobDemanda !== undefined) {
            params = params.append('sobDemanda', this.sobDemanda.toString());
        }

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.idsAreas = [];
        this.situacoes = [];
        this.tiposPromocoes = [];
        this.tipoPromocaoNull = false;
        this.sobDemanda = null;
    }
}

